import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import React from 'react'
import Icon from '@dustin-web/microsite-components/src/icon'

const InvalidCustomer = () => {
    const { translate } = useTranslations()

    return (
        <div className="row flex-column flex-lg-row">
            <div className="col">

                <h2>
                    {translate("FEDERATED_ACCESS_INVALID_CUSTOMER")}
                </h2>
                <p>
                    {translate("FEDERATED_ACCESS_INVALID_CUSTOMER_BODY")}
                </p>
            </div>
            <div className="col d-none d-lg-flex align-items-center justify-content-center">

                <Icon
                    className='i-80'
                    name="info-attention" />
            </div>
        </div>
    )
}

export default InvalidCustomer